"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SummaryKeyValuePair = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SummaryKeyValuePair = exports.SummaryKeyValuePair = function SummaryKeyValuePair(_ref) {
  var label = _ref.label,
    labelTooltip = _ref.labelTooltip,
    value = _ref.value,
    formatter = _ref.formatter,
    isTotal = _ref.isTotal;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "summaryKeyValuePair ".concat(isTotal ? 'total' : '')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, label, labelTooltip && /*#__PURE__*/_react["default"].createElement(_components.Tooltip, null, labelTooltip)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "value ".concat(value && "".concat(value).indexOf('-') === 0 ? 'discount' : '')
  }, formatter ? formatter(value) : value));
};
SummaryKeyValuePair.propTypes = {
  label: _propTypes["default"].string,
  labelTooltip: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  formatter: _propTypes["default"].func,
  isTotal: _propTypes["default"].bool
};